import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Row, Col } from 'reactstrap';
import Swiper from 'react-id-swiper';
import _ from 'lodash'

import { Images360 } from '../../constants/images360';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { getVideoOrChannelRelatedData } from '../../actions/PlayActions';
import { showMessage } from '../../actions/FlashMessageActions';
import { setHeaderTitle } from '../../actions/HeaderActions';
import { FormattedMessage } from 'react-intl';

import { Pannellum } from "pannellum-react-vc";


class PanoramicView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isRTL: false,
            data: {},
            isPlaying: false,
            playUrl: '',
            subCategoryData:[],
            videoData:props.play.data.video,
            selectedImage:[],
            selectedCategroy:[]
        };

        this.goToPlayImage = this.goToPlayImage.bind(this);
    }

    componentWillMount() {
        const params=this.props.match.params;
        let categoryData = Images360.filter(data=>data.id===parseInt(params.catId));
        let selectedImage = categoryData[0].images.filter(data=>data.id===parseInt(params.imageId));
        this.setState({
            selectedImage:selectedImage,
            selectedCategroy:categoryData
        })
        // if (this.props.play.data.video) {
            // this.props.setHeaderTitle(this.props.play.data.video.name);
            // this.getVideoCategories(this.props.play.data.video.id);
        // }
    }

    shouldComponentUpdate() {
        return true;
    }

    componentDidUpdate() {
        // this.toggleVideoDescription();
    }

    componentDidMount() {
        document.body.classList.add("play-page");
        window.scrollTo(0, 0);
        // this.getVideo(this.state.data.video.id);
        // this.toggleVideoDescription();
    }



    componentWillReceiveProps(nextProps) {
        window.scrollTo(0, 0);

        // if (this.props.play.data.video.id != nextProps.play.data.video.id) {
            // this.props.setHeaderTitle(nextProps.play.data.video.name);
            // this.getVideoCategories(nextProps.play.data.video.id);
        // }
        // this.toggleVideoDescription();
    }

    componentWillUnmount() {
        document.body.classList.remove("play-page");
    }


    goToPlayImage(imgData, event) {
        event.preventDefault();
        const params=this.props.match.params;
        let categoryData = Images360.filter(data=>data.id===parseInt(params.catId));
        let selectedImage = categoryData[0].images.filter(data=>data.id===parseInt(imgData.imageData.id));
        this.setState({
            selectedImage:selectedImage,
            selectedCategroy:categoryData
        })
        this.props.history.push(`/panoramic-show/${params.catId}/${imgData.imageData.id}`);
    }


    render() {


        const sliderData = {
                slidesPerView: 'auto',
                speed: 400,
                spaceBetween: 30,
                breakpoints: {
                    575: {
                        direction: 'vertical',
                        slidesPerView: 'auto',
                        speed: 400,
                        spaceBetween: 0,
                        touchReleaseOnEdges: true,
                    }
                }
            }

        let {selectedImage,selectedCategroy} = this.state;
        const params=this.props.match.params;
        return (
            <section className="play play-bg pb-0 video-active">
                <Row>
                    <Col xs="12">
                        {selectedImage.length>0?
                            <div className={this.state.isRTL? "play-bg ar": ""}>
                                <div className="video">

                                      <Pannellum
                                            width="100%"
                                            height="500px"
                                            image={selectedImage[0].ImageUrl}
                                            pitch={10}
                                            yaw={180}
                                            hfov={110}
                                            autoLoad
                                            onLoad={() => {
                                            }}
                                        >
                                      </Pannellum>  
                                 
                                    
                                    <div className="video__details__wrap">
                                        {/* <div className="video__details"> */}
                                            {/* <div className="video__head">
                                                <h3 className="video__title">{selectedImage.name}</h3>
                                                <div className="video__head__ratings">
                                                    
                                                </div>
                                            </div>
                                            <div className="video__sub-head">
                                                
                                            </div> */}
                                            {/* <p className={video.category.name == "Arabic Movies" || video.category.name == "Documentaries" ? "video__desc ar" : "video__desc"} ref={'desc'}>{(video.video.desc)? video.video.desc : ""}</p> */}
                                           
                                            <div className="video__desc__btn-wrap">
                                                <button className="btn-unstyled video__desc__btn">
                                                <FormattedMessage id="showMore"
                                                    defaultMessage="Show More"
                                                />
                                                </button>
                                            </div>
                                            
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                            : ""
                        }

                    </Col>
                </Row>
                    {selectedCategroy.length>0?
                        <Row>
                            <Col xs="12">
                                <div className="related-wrap">
                                    <div className="category-head related-top-links">
                                        <h3 className="primary-text">
                                        <FormattedMessage id="relatedImages"
                                                    defaultMessage="Related Images"
                                                />
                                        </h3>
                                    </div>
                                    <div> 
                                        <Swiper {...sliderData} rebuildOnUpdate={true} shouldSwiperUpdate={true}>
                                            {selectedCategroy[0].images.map((v) => { 
                                                if (v.id != parseInt(params.imageId)) {
                                                    return (
                                                        <div key={v.id} className="related-slide image360-center-align" style={{justifyContent:'center'}} href="javascript:void()" onClick={this.goToPlayImage.bind(this, {imageData: v})} >
                                                            <div className="image360-channels-thumb channels-thumb channels-thumb--genre">
                                                                <div className="channels-image channels-image--genre no-radius">
                                                                    <img className="channels-thumb__image channels-thumb__image--genre rounded-0" src={v.ImageUrl} alt={v.name} />
                                                                </div>
                                                                
                                                            </div>
                                                            {/* <div className="channels-thumb__details channels-thumb__details--related">
                                                                <div className="channels-thumb__inner channels-thumb__inner--related">
                                                                    <div className="channels-thumb__name channels-thumb__name--related">
                                                                        {v.name}
                                                                        
                                                                        <span className="channel-show__name">{v.duration}</span>
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                        </div>
                                                    )
                                                }
                                            })}
                                        </Swiper>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        : ""
                    }
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getVideoOrChannelRelatedData,
        showMessage,
        setHeaderTitle,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(PanoramicView);


// WEBPACK FOOTER //
// ./src/components/Panoramic/PanoramicView.js